import {observable} from 'mobx';
import {construct, ModelProperties, createArrayInstance, createInstance} from 'utils';
import {UserTranslator} from './user-translator';
import {AccessRole} from './access-role';

export class User {
    @observable id!: number;

    @observable username!: string;

    @observable password?: string;

    @observable roles?: AccessRole[];

    @observable translator?: UserTranslator;

    constructor(account?: ModelProperties<User>) {
        if (account) {
            construct(this, account);
            account.roles = createArrayInstance(AccessRole, account.roles);
            account.translator = createInstance(UserTranslator, account.translator);
        }
    }
}